export type RevenueRecognitionMethod =
  | 'MILESTONE'
  | 'STRAIGHT_LINE'
  | 'USAGE'
  | 'POINT_IN_TIME'

export type RevenueClassification = 'PREPAYMENT' | 'EARNED' | 'BURNDOWN'

export const revenueRecognitionOptions: Array<{
  value: RevenueRecognitionMethod
  label: string
}> = [
  {
    label: 'Milestone',
    value: 'MILESTONE'
  },
  {
    label: 'Straight line',
    value: 'STRAIGHT_LINE'
  },
  {
    label: 'Usage',
    value: 'USAGE'
  },
  {
    label: 'Point in time',
    value: 'POINT_IN_TIME'
  }
]

export type LedgerAccountName =
  | 'RECOGNIZED_REVENUE'
  | 'UNBILLED_REVENUE'
  | 'BILLED_REVENUE'
  | 'DEFERRED_REVENUE'

export const revenueClassificationOptions: Array<{
  value: RevenueClassification
  label: string
}> = [
  { label: 'In arrears', value: 'EARNED' },
  { label: 'In advance', value: 'PREPAYMENT' }
]
